const userInformation = {
  en: {
    translation: {
      title: "Visitor Information",
      birth_date: "Birth date",
      city: "City",
      card: "Card number",
      gender: "Gender",
      female: "Female",
      male: "Male",
      other: "Other",
      name: "Name",
      surname: "Surname",

      info_empty: "There are no tickets, go back to the ticket office",
      // ERROR
      error_birth_day: "Enter date of birth",
      error_country: "Enter city of origin",
      error_name: "Enter name",
      error_surname: "Enter surname",
      error_card_expired: "Error. Card expired on ",
      error_card_inexistent: "Error. Card inexistent",
      error_card_repetitions:
        "Error. A card can only correspond to a single visitor",
      error_mandatory: "Compile all the mandatory fields in order to continue",
    },
  },
  it: {
    translation: {
      title: "Informazioni visitatore",
      birth_date: "Anno di nascita",
      city: "Città",
      card: "Numero tessera",
      gender: "Genere",
      female: "Donna",
      male: "Uomo",
      other: "Altro",
      name: "Nome",
      surname: "Cognome",
      info_empty: "Non ci sono biglietti, torna alla biglietteria",
      // ERROR
      error_birth_day: "Inserisci anno di nascita",
      error_country: "Inserisci la città di provenienza",
      error_name: "Inserisci nome",
      error_surname: "Inserisci cognome",
      error_card_expired: "Errore. Card scaduta il ",
      error_card_inexistent: "Errore. Card inesistente",
      error_card_repetitions:
        "Errore. Ogni tessera può corrispondere a un solo visitatore",
      error_mandatory: "Compila tutti i campi obbligatori per poter proseguire",
    },
  },
};

export default userInformation;
